import React from 'react';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import Schema from './schema';

const NewsGridEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const schema = Schema(props);
  return (
    <>
      <View data={data} block={block} emEdicao />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default NewsGridEdit;
